import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { JwtInterceptor } from "@auth0/angular-jwt";
import { catchError, switchMap } from "rxjs/operators";
import { Router } from "../../../node_modules/@angular/router";
import { AuthService } from "./auth-service.service";
import { NbToastrService } from "@nebular/theme";
import { environment } from "../../environments/environment";

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  constructor(private jwtInterceptor: JwtInterceptor, private router: Router, private toastrService: NbToastrService, private _authService: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.jwtInterceptor.isAllowedDomain(req) && !this.jwtInterceptor.isDisallowedRoute(req)) {
      return next.handle(req).pipe(
        catchError((err) => {
          const errorResponse = err as HttpErrorResponse;
          if (errorResponse.status === 401) {
            this._authService.logout();
            this.toastrService.warning('De sessie is verlopen, je moet opnieuw inloggen.', 'Sessie is verlopen');
            this.router.navigate(['auth', 'login']);
          } else {
            return throwError(err);
          }
        }));
    } else {
      return next.handle(req);
    }
  }
}

